import { InjectionToken, Signal } from '@angular/core'

/**
 * Where "home" is for a signed-in user. `court-system` is the current court's page, or court
 * selection when none is chosen. `root` is the app root.
 */
export type HomeRoute = 'court-system' | 'root'

export const HOME_ROUTE = new InjectionToken<Signal<HomeRoute>>('HOME_ROUTE')
